import React from 'react';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import ClockCircleOutlined from '@ant-design/icons/ClockCircleOutlined';
import { TIME } from '../generatePicker/constant';
const SuffixIcon = ({ picker, hasFeedback, feedbackIcon, suffixIcon, }) => {
    if (suffixIcon === null || suffixIcon === false) {
        return null;
    }
    if (suffixIcon === true || suffixIcon === undefined) {
        return (React.createElement(React.Fragment, null,
            picker === TIME ? React.createElement(ClockCircleOutlined, null) : React.createElement(CalendarOutlined, null),
            hasFeedback && feedbackIcon));
    }
    return suffixIcon;
};
export default SuffixIcon;
